import { render, staticRenderFns } from "./alipay-check.vue?vue&type=template&id=c0662cea&"
import script from "./alipay-check.vue?vue&type=script&lang=js&"
export * from "./alipay-check.vue?vue&type=script&lang=js&"
import style0 from "./alipay-check.vue?vue&type=style&index=0&id=c0662cea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports